import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useLayoutEffect } from 'react';

import { Login, NotFoundPage } from '@bepro-travel/fe.shared';
import usePreserveUTMParams from './hooks/usePreserveUTMParams';
import MainPage from './components/MainPage';
import OphirResultsPage from './components/Result/OphirResultsPage';
import OphirDetailsPage from './components/Details/OphirDetailsPage';
import OphirBookPage from './components/Book/OphirBookPage';
import OphirSuccessPage from './components/Book/OphirSuccessPage';
import OphirPaymentPage from './components/Book/OphirPaymentPage';
import GuidesPage from './components/GuidesPage';
import GuideDetailsPage from './components/GuideDetailsPage';

const Router = () => {
  const location = useLocation();
  usePreserveUTMParams();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const pages: any[] = [
    { path: '/', component: MainPage },
    { path: '/TourRuPackages/*', component: MainPage },
    { path: '/tourru/results', component: OphirResultsPage },
    { path: '/tourru/details', component: OphirDetailsPage },
    { path: '/tourru/book', component: OphirBookPage },
    { path: '/tourru/success', component: OphirSuccessPage },
    { path: '/tourru/payment', component: OphirPaymentPage },
    { path: '/guides', component: GuidesPage },
    { path: '/guides/:guideUrl', component: GuideDetailsPage },
    { path: '/pages', component: MainPage },
    { path: '/pages/*', component: MainPage },
  ];

  return (
    <Routes>
      {pages.map(({ component: Component, path }) => {
        return <Route key={path} path={path} Component={Component} />;
      })}
      <Route element={<NotFoundPage />} path="*" />
    </Routes>
  );
};

export default Router;
